import { Backdrop, Button, CircularProgress, Grid, Stack, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import CustomSnackbar from '../../components/ui-component/snackbar/CustomSnackbar';

export default function AcceptRecycleWithNote({id}) {
      const [note, setNote] = useState(null);
        const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const userId = localStorage.getItem("userId");
  const [isLoading, setIsLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  
    const showSnackbar = (message, severity) => {
      setSnackbarMessage(message);
      setSnackbarSeverity(severity);
      setSnackbarOpen(true);
    };
  
      const handleAcceptRecycleRequest = () => {
if(!note){
    showSnackbar("Please add note", 'error')
    return
}

   setIsLoading(true);
          const data = {
            user_id: parseInt(userId),
            //enquiry_id: id,
            status: "accepted",
            is_active: false,
            notes:note
          };
      
          // Send the POST request to the server
          fetch(`${API_ENDPOINT}recyclerequest/updatebyEnquiryId/${id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              if (response.ok) {
                showSnackbar("Recycle Request accepted successfully", "success");
                // alert("Recycle Request accepted successfully");
                   setIsLoading(false);
                setTimeout(() => {
                  window.location.reload();
                }, 1200);
              } else {
                showSnackbar("Error accepting recycle request", "error");
                alert("Error accepting recycle request");
                   setIsLoading(true);
                //window.location.reload()
              }
            })
            .catch((error) => {
              console.error("Error submitting data:", error);
              showSnackbar(
                "Network Error accepting recycle request. Please try again",
                "error"
              );
              alert("Network Error accepting recycle request. Please try again");
                 setIsLoading(true);
              //window.location.reload()
            });
        };

  return (
   <>
   <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Stack direction="row" spacing={1}>
          <Typography
            variant="h4"
            color="secondary"
            fontWeight={800}
            marginRight={2}
          >
            Accepting recycle request ...
          </Typography>
          <CircularProgress color="primary" />
        </Stack>
      </Backdrop>
<Grid container spacing={2}>
           <Grid item xs={12}>
              <Typography variant="h6">
                Note{" "}
                <span
                  style={{
                    color: "red",
                    position: "absolute",
                    marginLeft: "4px",
                    fontSize: "1em",
                  }}
                >
                  *
                </span>
              </Typography>
              <TextField
                size="small"
                multiline
                rows={4}
                onChange={(e) => setNote(e.target.value)}
                fullWidth
                InputProps={{
                  style: {
                    borderRadius: "15px",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} lg={12} md={12} sm={12} textAlign="end">
          <Button variant="contained" onClick={handleAcceptRecycleRequest}>
            {" "}
            Submit
          </Button>
        </Grid>
</Grid>
<CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
   </>
  )
}
